import React from 'react'
import './PlacedOrder.css'
import { useContext } from "react";
import { UserContext } from "./OrderPlacement/OrderContext";
import { useNavigate } from 'react-router-dom';
export default function PlacedOrder(){
        const { orderMSG, orderCode } = useContext(UserContext);
    const navigate = useNavigate()
    return(
        <>
        <div className="informuser">
            <i class="fa-regular fa-circle-check"></i>
            <div className="textorderplaced">
                <h2>#{orderCode}</h2>
                <p>{orderMSG}</p>
                <button onClick={()=> navigate('/')}><i class="fa-solid fa-house"> Back To Home</i></button>
            </div>
        </div>
        </>
    )
}